import React from 'react'
import { Card, CardGroup, Col, Row } from 'react-bootstrap'

const AmazonBooks = () => {
  return (
    <>
        <Card className='no-border rounded-0 architectural-modeling container'>
            <Card className='text-center no-border rounded-0'>
                <Card.Body>
                    <Card.Title className='architectural-modeling-title'> 小売業の未来 </Card.Title>
                    <Card.Text className='architectural-modeling-text text-left'>
                    没入型バーチャル小売環境におけるeコマースの未来のデモンストレーションとして、私たちは実際の実店舗と書店のデジタルツインを作成しました。VRの中でユーザーは、仮想店舗全体を回り、オンラインのおすすめ商品から選んだ本を手に取って閲覧し、仮想の買い物かごに本を入れて、現実世界に戻るとオンラインショッピングのカートの中保存された本を確認することができます。
                    </Card.Text>
                    <CardGroup className='amazon-books-cardgroup'>
                        <Row>
                            <Col md={{span:6, offset:0}}>
                                <Card className='no-border rounded-0 architectural-modeling-card px-2'>
                                    <Card.Img className='amazon-books-images' src={"/assets/amazon-books/images/amazon_001.jpg"} />
                                    <Card.Body>
                                    <Card.Title className='architectural-modeling-footer-title'>現実世界の書店 <br /> （参考写真）</Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col md={{span:6, offset:0}}>
                                <Card className='no-border rounded-0 architectural-modeling-card px-2'>
                                    <Card.Img className='amazon-books-images' src={"/assets/amazon-books/images/amazon_001_01.jpg"} />
                                    <Card.Body>
                                    <Card.Title className='architectural-modeling-footer-title'>仮想空間（VR）の書店 <br /> （3Dモデルのレンダリング画像）</Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </CardGroup>

                    <CardGroup className='amazon-books-cardgroup mt-5'>
                        <Row>
                            <Col md={{span:6, offset:0}}>
                                <Card className='no-border rounded-0 architectural-modeling-card px-2'>
                                    <Card.Img className='amazon-books-image-second' src={"/assets/amazon-books/images/amazon_002.jpg"} />
                                    <Card.Body>
                                    <Card.Title className='architectural-modeling-footer-title'>現実世界の書店 <br /> （参考写真）</Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col md={{span:6, offset:0}}>
                                <Card className='no-border rounded-0 architectural-modeling-card px-2'>
                                    <Card.Img className='amazon-books-images' src={"/assets/amazon-books/images/amazon_002_01.jpg"} />
                                    <Card.Body>
                                    <Card.Title className='architectural-modeling-footer-title'>仮想空間（VR）の書店 <br /> （3Dモデルのレンダリング画像）</Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </CardGroup>
                </Card.Body>
            </Card>
        </Card>
      
    </>
  )
}

export default AmazonBooks
